/**
 * ReportTemplatesCtrl controller
 * Show all saved report templates
 */

import {
  REPORT_TYPES,
  USERS_REPORT_TYPES,
  PAYMENT_SYSTEM_TYPES,
  REPORT_FINANCIAL_PERIODS,
  REPORT_FINANCIAL_PRODUCT_TYPES, PURCHASE_STATUSES_FOR_FINANCIAL_REPORT
} from 'app/core/constants'
import { has } from 'app/helpers/object'

/**
 * ReportTemplatesCtrl controller
 *
 * @class ReportTemplatesCtrl
 * @memberof mwApp/reports
 * @see mwApp/reports
 *
 * @ngdoc controller
 * @name mwApp/reports.controller:ReportTemplatesCtrl
 */
/* @ngInject */
export default function ReportTemplatesCtrl ($rootScope, $scope, $location, ReportTemplate, ReportFinancialTemplate,
  ReportTransactionTemplate, ReportStreamTemplate, ReportSubscribersTemplate, ReportUsersTemplate, commonData, scope) {
  var vm = this

  /**
   * Report types
   *
   * @memberof mwApp/reports.controller:GeneratedReportsCtrl
   * @type {Object}
   */
  vm.report_types = REPORT_TYPES
  vm.report_financial_periods = REPORT_FINANCIAL_PERIODS
  vm.purchase_item_statuses = PURCHASE_STATUSES_FOR_FINANCIAL_REPORT
  vm.report_financial_product_types = REPORT_FINANCIAL_PRODUCT_TYPES
  vm.payment_system_types = PAYMENT_SYSTEM_TYPES

  vm.reportType = scope.reportType
  // check report type
  let ReportModel = ReportTemplate
  switch (scope.reportType) {
    case 'stream':
      ReportModel = ReportStreamTemplate
      break
    case 'subscribers':
      ReportModel = ReportSubscribersTemplate
      break
    case 'financial':
      ReportModel = ReportFinancialTemplate
      break
    case 'transaction':
      ReportModel = ReportTransactionTemplate
      break
    case 'users':
      ReportModel = ReportUsersTemplate
      vm.report_types = USERS_REPORT_TYPES
      break
    default: break
  }

  /**
   * Listen tab event
   */
  $scope.$on('dispatch: reports_list', function () {
    $scope.$broadcast('refreshTable')
  })

  /**
   * isFound Flag
   *
   * @memberof mwApp/reports.controller:ReportTemplatesCtrl
   * @type {Boolean}
   */
  vm.isFound = true

  /**
   * Report templates list
   *
   * @memberof mwApp/reports.controller:ReportTemplatesCtrl
   * @type {models.Report[]}
   */
  vm.templates = []

  /**
   * Payment system types
   *
   * @memberof mwApp/reports.controller:GeneratedReportsCtrl
   * @type {Object}
   */
  vm.payment_system_types = PAYMENT_SYSTEM_TYPES

  /**
   * Module data
   *
   * @type {Object}
   */
  vm.commonData = commonData.data

  vm.subscriptionsFilter = [].concat(scope.subscriptions)

  vm.getSubscriptionName = function (id) {
    return vm.subscriptionsFilter.find(sub => sub.id === id).name
  }

  /**
   * Get list of report templates from backend
   *
   * @memberof mwApp/reports.controller:ReportTemplatesCtrl
   * @param {Object} tableState - smart table state object
   */
  vm.getTemplates = function (tableState) {
    // set default sort by id
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'id'
      tableState.sort.reverse = false
    }
    if (scope.reportType === 'financial' || scope.reportType === 'transaction') {
      tableState.mappingParams = {}
      tableState.mappingParams.organizationName = 'organization-name'
    }

    ReportModel.loadSmart(tableState)
      .then(data => {
        vm.templates = data.content
        vm.isFound = !!vm.templates.length
      })
  }

  /**
   * Generate template
   *
   * @memberof mwApp/reports.controller:ReportTemplatesCtrl
   * @param template
   */
  vm.generateTemplate = function (template) {
    template._generate()
      .then(function (response) {
        commonData.data.update('lastReport', has('payload')(response.data)
          ? response.data.payload.id
          : response.data.id)
        commonData.data.update('lastTemplate')

        $rootScope.$broadcast('refreshTable')
        $location.hash('generated_reports')
        vm.location.reload()
      })
  }

  /**
   * Delete template
   *
   * @memberof mwApp/reports.controller:ReportTemplatesCtrl
   * @param template
   */
  vm.deleteTemplate = function (template) {
    template._delete(`${template.name} report template deleted`)
      .then(() => $scope.$broadcast('refreshTable'))
  }
}
